import { Button, Flex, isNullish, Text } from "@theorgchartdev/storybook";
import React from "react";
import BasicChartSearchMenu from "@/appComponents/Blocks/Menus/BasicChartSearchMenu/BasicChartSearchMenu";
import { RecordValueRow } from "@/appComponents/Blocks/Cards/RecordInfoCard/RecordValueRow";
import { GetDoc } from "@/Utils/StateLib";
import { usePermissionCheck } from "@/hooks/usePermissionCheck";
import { RecordDisplayLabel } from "@/appComponents/Blocks/Composites/RecordDisplayLabel/RecordDisplayLabel";
import cx from "classnames";
import { getDisplayMap } from "@/appComponents/Blocks/Cards/ProfileBaseballCard/getDisplayMap";
import {
  MainDisplayFieldIds,
  PositionHoldersDisplayFieldIds,
  PositionMainDisplayFieldNames
} from "@/Utils/Constants";
import { GetFieldDefFromName } from "@/Utils/DataLib";
import { FormatFieldValue } from "@coreapp/utils/FormatFieldValue";
import { appstr } from "@coreapp/utils/appstr";
import {
  enumObjClassNames,
  kEmployeeID,
  kPositionDivisionID,
  kPositionID,
  kPositionTitleID
} from "@coreapp/constants";

const GetSuperIDDef = dbObj => {
  const classDef = dbObj?.GetParentClass();
  return classDef.GetFieldDefByID("SupervisorID");
};

const GetSearchPlaceholder = (
  dbObj /* QObjDBObject | undefined */,
  recordSupervisor /* QObjDBObject | null */
) => {
  if (!isNullish(recordSupervisor)) {
    const classDef = recordSupervisor.GetParentClass();
    const nameDef = classDef.GetFieldDefByID("Name");
    return recordSupervisor.GetFieldValue(nameDef);
  }

  if (!isNullish(dbObj)) {
    return dbObj.SmartGetFieldValue("Reports To Name");
  }

  return appstr("No reports");
};

export const RecordEditLabel = props => {
  const doc = GetDoc();
  const { canEditDocuments } = usePermissionCheck();
  const canAccessEditing = canEditDocuments && !doc?.IsServerChart();

  const isPositionObj = props.dbObj?.IsPositionObj();
  const isPositionDocument = doc.IsPositionDocument();
  const objClassName = props.dbObj?.InferObjectClassName() || enumObjClassNames.box;
  const displayNames = isPositionDocument
    ? isPositionObj
      ? PositionMainDisplayFieldNames
      : PositionHoldersDisplayFieldIds
    : MainDisplayFieldIds;
  const basicFields = isPositionDocument
    ? isPositionObj
      ? [kPositionTitleID, kPositionID, kPositionDivisionID]
      : ["Name", "EmployeeID", "Title", "Division", "Location"]
    : ["Name", "PersonID", "Title", "Division", "Location"];

  const fieldMap = getDisplayMap(displayNames, objClassName);
  const recordData = props.dbObj?.JSON() ?? {};

  const editButtonClass = cx("oc-special-secondary", "oc-special-secondary--fit");
  const superFieldDef = GetSuperIDDef(props.dbObj);

  // {FieldId: dataRow} map so we can easily display values in specific order
  const dataDict = props.data.reduce((acc, item) => {
    acc[item.fieldDef.GetFieldID()] = item;
    return acc;
  }, {});

  const data = basicFields.map(field => dataDict[field]).filter(Boolean);

  const SanitizeValue = field => {
    if (!field || !recordData[field]) return appstr("Blank");
    const fD = GetFieldDefFromName(field, objClassName);
    if (fD) {
      return FormatFieldValue(recordData[field], fD);
    }
  };

  const isEditing = false;

  return (
    <Flex direction={"column"} width={"100%"}>
      <Flex justifyContent={"space-between"} width={"100%"} alignItems={"center"}></Flex>
      <RecordDisplayLabel
        name={SanitizeValue(fieldMap.name)}
        id={SanitizeValue(fieldMap.id)}
        title={SanitizeValue(fieldMap.title)}
        dept={SanitizeValue(fieldMap.dept)}
        photoSrc={null}
        showTitle={!isPositionObj}
      />
    </Flex>
  );
};
